import React, { Component } from "react"
import { Popup } from "semantic-ui-react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faInfoCircle, faArrowUp, faArrowDown } from "@fortawesome/free-solid-svg-icons"

class HeaderWithInfo extends Component {
  state = { sort: null }

  componentDidMount() {
    this.props.column.addEventListener("sortChanged", this.onSortChanged)
  }

  componentWillUnmount() {
    this.props.column.removeEventListener("sortChanged", this.onSortChanged)
  }

  onSortChanged = () => {
    const { column } = this.props
    const sort = column.isSortAscending() ? "asc" : column.isSortDescending() ? "desc" : null
    this.setState({ sort })
  }

  onSortClick = () => {
    if (this.props.enableSorting) {
      this.props.progressSort()
    }
  }

  render() {
    const { displayName, tooltip, enableSorting } = this.props
    const { sort } = this.state
    return (
      <div
        style={{
          display: "flex",
          gap: "6px",
          alignItems: "center",
          cursor: enableSorting ? "pointer" : "default",
          height: "100px"
        }}
        onClick={this.onSortClick}
      >
        <span>{displayName}</span>
        {sort === "asc" && <FontAwesomeIcon icon={faArrowUp} />}
        {sort === "desc" && <FontAwesomeIcon icon={faArrowDown} />}
        <Popup
          content={tooltip}
          inverted
          position="right center"
          trigger={
            <FontAwesomeIcon
              icon={faInfoCircle}
              style={{ cursor: "pointer", zIndex: 999 }}
              onClick={(e) => e.stopPropagation()}
            />
          }
        />
      </div>
    )
  }
}

export default HeaderWithInfo
